import axios from "axios";
import Cookies from "js-cookie";
import { watchApi } from "../shared/lib/apiStatus";

const baseUrl = process.env.REACT_APP_SERVER_BASE_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 300000, // 5 minutes timeout for heavy admin page queries
});

axiosInstance.interceptors.request.use(
  async (request) => {
    const accessToken = Cookies.get("vb-access-token");

    if (accessToken) {
      request.headers["Authorization"] = "Bearer " + accessToken;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// one refresh at a time: requests failing together wait for the same new token
let refreshing = null;
const refreshToken = () => {
  if (!refreshing) {
    refreshing = axios
      .post(`${baseUrl}/auth/refresh`, { refreshToken: Cookies.get("vb-refresh-token") })
      .then(({ data }) => {
        Cookies.set("vb-access-token", data.newAccessToken);
        return data.newAccessToken;
      })
      .finally(() => {
        refreshing = null;
      });
  }
  return refreshing;
};

axiosInstance.interceptors.response.use(
  (config) => {
    return config;
  },
  async (err) => {
    const originalRequest = err.config;

    if (
      err.response?.data?.code === 401 &&
      Cookies.get("vb-access-token") &&
      Cookies.get("vb-refresh-token") &&
      // once per request: a second 401 after a fresh token is a real "no"
      // (looping here sent hundreds of requests a minute)
      originalRequest &&
      !originalRequest._isRetry
    ) {
      try {
        originalRequest._isRetry = true;
        await refreshToken();
        return axiosInstance.request(originalRequest);
      } catch (err) {
        console.log(err);
        
        // Проверяем, не просматривает ли администратор страницу автора
        const isAdminViewingAuthor = window.location.pathname.includes('licensors') && 
                                    window.location.search.includes('auth_hash');
        
        if (isAdminViewingAuthor) {
          // Для админа не удаляем токены, а перенаправляем на страницу админа
          window.location.assign("/admin");
        } else {
          // Стандартное поведение - удаляем токены и перенаправляем на логин
          Cookies.remove("vb-refresh-token");
          Cookies.remove("vb-access-token");
          window.location.assign("/login");
        }
      }
    }
    throw err;
  }
);

// a backend update: "reconnecting" banner + GET retries
watchApi(axiosInstance);

export default axiosInstance;
